import { SummaryRow } from '../../../Summary/SummaryRow';
import { Q } from '../../../../store/student/types';

interface Props {
  showRisks: boolean;
  withAgent?: string;
  riskList?: string[];
}

function CriminalConvictionAndDisability({ showRisks, withAgent, riskList = [] }: Props) {
  return (
    <>
      {withAgent && (
        <SummaryRow
          key="workingWithAgent"
          label="With Agent"
          fullLabel="Did anyone help you submit your application to study with us?"
          value={
            withAgent === 'No'
              ? 'No, I did it myself'
              : withAgent === 'School'
                ? 'Yes, a school counsellor'
                : withAgent === 'Agent'
                  ? 'Yes, an agent'
                  : 'Yes, someone else'
          }
          isRisk={showRisks && riskList.includes(Q.AGENT)}
        />
      )}
    </>
  );
}

export default CriminalConvictionAndDisability;
